import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import type { NotificationCreatedPayload } from '@/integrations/signalr'
import { useUserHubEvent } from '@/integrations/signalr'
import { logger } from '@/lib/logger'

export function useNotificationRealtime() {
  const queryClient = useQueryClient()

  useUserHubEvent<NotificationCreatedPayload>(
    'Notification',
    useCallback(
      (payload) => {
        logger.debug(
          'Notification received, invalidating queries',
          { payload },
          'notifications',
        )
        queryClient.invalidateQueries({ queryKey: ['notifications'] })
        queryClient.invalidateQueries({ queryKey: ['notification-stats'] })
      },
      [queryClient],
    ),
  )
}
